import { mapActions } from 'vuex'
import eventBus from './js/eventBus.js'
import store from './store'
import api from '@/api'

export default {
  data() {
    return {
      EventBus: eventBus,
      gapi: window.gapi,
      // trackingEvents:[]
    }
  },
  computed: {
    isLoggedIn() {
      return store.getters.isLoggedIn
    },
    isPublic() {
      return store.getters.isPublic
    },
    isChatOpen() {
      return store.getters.isChatOpen
    },
    isAdmin() {
      return store.getters.isAdmin
    },
    loadingBool: () => {
      return store.getters.globalLoading;
    },
    routerHistory: () => {
      return store.getters.routerHistory;
    },
    getKey: () => {
      return store.getters.getKey;
    },
    globalFairConfig: () => {
      return store.getters.globalFairConfig;
    },
    trackingEvents: () => {
      return store.getters.trackingEvents;
    },
  },
  methods: {
    ...mapActions(['setChat', 'updateFairConfig', 'setLoggedIn', 'saveUniqueKey', 'setIsPublic', 'setIsAdmin', 'popHistoryTwice', 'setTrackingEvents', 'setPermissions']),
    async callApiForClosePoll (pls_id) {
      try {
        let res = await api.closedPoll({pls_id});
        console.log(res.data);
      } catch (error) {
        console.warn(error);
      }
    },
    postEventTracking(obj) {
      if (this.globalFairConfig.FC_TRACKING == "0") {
        return
      }
      this.setTrackingEvents(obj)
    },
    async submitEventTracking() {
      try {
        if (this.globalFairConfig.FC_TRACKING == "0" || this.trackingEvents.length < 1) {
          return
        }
        const res = await api.postTracking({ events: this.trackingEvents })
        if (res.data.result == "ok") {
          this.setTrackingEvents(null)
          console.log(this.trackingEvents);
        }
      } catch (error) {
        console.log(error);
      }
    },
    startLoading() {
      if (store.getters.globalFairConfig.FC_LOADER == 1) {
        store.dispatch("setLoading", true);
      }
    },
    stopLoading() {
      if (store.getters.globalFairConfig.FC_LOADER == 1) {
        store.dispatch("setLoading", false);
      }
    },
    customError(text) {
      let error = {
        message: text
      }
      this.EventBus.$emit("error", error);
    },
    openToast(text) {
      let info = {
        message: text
      }
      this.EventBus.$emit("info", info);
    },
    getMyUsrId() {
      let usr_id = localStorage.getItem('usr_id');
      return usr_id;
    },
    getImageUsrId(id) {
      let sid = localStorage.getItem('sid');
      let link = process.env.VUE_APP_API_URL + `/users/image?usr_id=${id}&sid=${sid}`
      return link;
    },
    getImageUsdId(id) {
      let sid = localStorage.getItem('sid');
      let link = process.env.VUE_APP_API_URL + `/users/image?usd_id=${id}&sid=${sid}`
      return link;
    },
    handleError(e) {
      this.EventBus.$emit('error', e);
      console.warn(e);
    },
    goBack() {
      let newPath = this.routerHistory[this.routerHistory.length - 1];
      if (newPath.includes("?")) {
        if (!newPath.includes("skip")) {
          newPath += "&skip=true";
        }
      } else {
        newPath += "?skip=true";
      }
      this.$router.push(newPath);
      setTimeout(() => {
        this.popHistoryTwice(); // this is important for chaining back buttons
      }, 0);
    },
    async apiCall(obj) {
      //obj.api => function of the api called
      //obj.params => params sent to the api function
      //obj.onError => errorhandle function
      //note: if you dont want error handled, pass an empty function (by default this.handleError(error))
      try {
        const res = await obj.api(obj.params);
        return res.data;
      } catch (error) {
        if (obj.onError) {
          obj.onError(error);
        } else {
          this.handleError(error);
        }
      }
    },
    checkPermissions(permissions) {
      const userPermissions = this.globalFairConfig.FC_PUBLIC == 1 && !store.state.isLoggedIn? store.state.publicPermissions : store.state.permissions;
      return userPermissions ? permissions.some(perm => userPermissions.includes(perm)) : false;
    },
    async getPermissions () {
      try {
        const res = await api.getUserPermissions();
        this.setPermissions(res.data.result);
      } catch (error) {
        this.handleError(error);
      }
    },
  },
}